import { useTypeSafeMutation } from '@oresundsbron/api';
import {
  CustomerValidationBody,
  CustomerValidationResult,
} from '@oresundsbron/api';
import { ValidationResult } from '@oresundsbron/use-form';
import { pipe } from 'fp-ts/lib/function';
import { map, tryCatch } from 'fp-ts/lib/TaskOption';
import { useCallback } from 'react';

export function useValidateCustomer() {
  const { mutateAsync } = useTypeSafeMutation(
    ['customer', 'validate'],
    (req) => req.Customer.validate
  );

  const validate = useCallback(
    <T>(
        validationResultFn: (
          result: CustomerValidationResult
        ) => ValidationResult<T>
      ) =>
      (body: CustomerValidationBody) =>
        pipe(
          tryCatch(() => mutateAsync(body)),
          map(validationResultFn)
        ),
    [mutateAsync]
  );

  return validate;
}
